/**
 * Created by huangzhangshu on 2018/8/8
 */
import React, {Component} from 'react';
import {connect} from 'dva';
import moment from 'moment';
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import {Form, Input, Icon, Button, Alert, DatePicker, Checkbox} from '@vadp/ui';
import styles from './index.less';
import {wrapImage} from '../../utils';

moment.locale('zh-cn');
const FormItem = Form.Item;

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      code: '',
      codeLength: 4,
      fontSizeMin: 20,
      fontSizeMax: 22,
      backgroundColorMin: 240,
      backgroundColorMax: 250,
      colorMin: 10,
      colorMax: 20,
      lineColorMin: 40,
      lineColorMax: 180,
      contentWidth: 96,
      contentHeight: 35,
      showError: false, // 默认不显示验证码的错误信息
      showVerify: true,
      visibility: 'hidden',
      isPasswordEye: false, // 密码框是否可以看见密码
    };
  }

  componentWillMount() {
    this.canvas = React.createRef();
  }

  componentDidMount() {
    // const {showLoginVerify} = this.props;
    // this.setState({visibility: 'visible'});
    localStorage.setItem('LOGIN_DATE', moment().format('YYYY/MM/DD'));
    localStorage.setItem('LOGIN_DATE_VALUE', moment().valueOf().toString());
    const loginUser = localStorage.getItem('loginUser') || '';
    // 用户名输入框默认获取焦点
    document.getElementById('username').focus();
    if(loginUser != "" ){
      this.props.form.setFieldsValue({
        username: loginUser,
      });
    }
    this.drawPic();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const {showLoginVerify} = nextProps;
    if (this.state.showVerify !== showLoginVerify) this.setState({showVerify: showLoginVerify});
    if (showLoginVerify && this.canvas.current == null) this.drawPic();
  }

  onChange = () => {
    const {dispatch} = this.props;
    dispatch({type: 'vadpLogin/updateStatus', payload: true});
  }
  mousedownEye = (event) => {
    const _this = this
    _this.setState({
      isPasswordEye: true,
    })
    window.document.onmouseup = function(){
      if(_this.state.isPasswordEye) {
        _this.setState({
          isPasswordEye: false,
        })
      }
    }
  }
  
  onDateChange = (date, dateString) => {
    localStorage.setItem('LOGIN_DATE', dateString);
    localStorage.setItem('LOGIN_DATE_VALUE', date.valueOf().toString());
  }

  // 生成一个随机数
  // eslint-disable-next-line arrow-body-style
  randomNum = (min, max) => {
    return Math.floor(Math.random() * (max - min) + min)
  }

  drawPic = () => {
    this.randomCode();
  }

  // 随机生成验证码
  randomCode() {
    let random = '';
    // 去掉了I l i o O,可自行添加
    const str = 'QWERTYUPLKJHGFDSAZXCVBNMqwertyupkjhgfdsazxcvbnm1234567890'
    for (let i = 0; i < this.state.codeLength; i++) {
      const index = Math.floor(Math.random() * 57);
      random += str[index];
    }
    this.setState({
      code: random
    }, () => {
      const canvas = this.canvas.current;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      ctx.textBaseline = 'bottom';
      // 绘制背景
      ctx.fillStyle = this.randomColor(this.state.backgroundColorMin, this.state.backgroundColorMax);
      ctx.fillRect(0, 0, this.state.contentWidth, this.state.contentHeight);
      // 绘制文字
      for (let i = 0; i < this.state.code.length; i++) {
        this.drawText(ctx, this.state.code[i], i);
      }
      this.drawLine(ctx);
      this.drawDot(ctx);
    });
  }

  // 生成一个随机的颜色
  // eslint-disable-next-line react/sort-comp
  randomColor(min, max) {
    const r = this.randomNum(min, max);
    const g = this.randomNum(min, max);
    const b = this.randomNum(min, max);
    return `rgb(${r}, ${g}, ${b})`;
  }

  drawText(ctx, txt, i) {
    ctx.fillStyle = this.randomColor(this.state.colorMin, this.state.colorMax);
    const fontSize = this.randomNum(this.state.fontSizeMin, this.state.fontSizeMax);
    ctx.font = fontSize + 'px SimHei';
    const padding = 10;
    const offset = (this.state.contentWidth - 40) / (this.state.code.length - 1);
    let x = padding;
    if (i > 0) {
      x = padding + (i * offset);
    }
    let y = this.randomNum(this.state.fontSizeMax, this.state.contentHeight - 5);
    if (fontSize > 40) {
      y = 40;
    }
    const deg = this.randomNum(-10, 10);
    // 修改坐标原点和旋转角度
    ctx.translate(x, y);
    ctx.rotate(deg * Math.PI / 180);
    ctx.fillText(txt, 0, 0);
    // 恢复坐标原点和旋转角度
    ctx.rotate(-deg * Math.PI / 180);
    ctx.translate(-x, -y);
  }

  drawLine(ctx) {
    // 绘制干扰线
    for (let i = 0; i < 1; i++) {
      ctx.strokeStyle = this.randomColor(this.state.lineColorMin, this.state.lineColorMax);
      ctx.beginPath();
      ctx.moveTo(this.randomNum(0, this.state.contentWidth), this.randomNum(0, this.state.contentHeight));
      ctx.lineTo(this.randomNum(0, this.state.contentWidth), this.randomNum(0, this.state.contentHeight));
      ctx.stroke();
    }
  }

  drawDot(ctx) {
    // 绘制干扰点
    for (let i = 0; i < 10; i++) {
      ctx.fillStyle = this.randomColor(0, 255);
      ctx.beginPath();
      ctx.arc(this.randomNum(0, this.state.contentWidth), this.randomNum(0, this.state.contentHeight), 1, 0, 2 * Math.PI);
      ctx.fill();
    }
  }

  reloadPic = () => {
    this.drawPic();
    this.props.form.setFieldsValue({
      code: '',
    });
    this.setState({userInputCode: ''});
  }

  // 输入验证码
  changeCode = e => {
    // this.setState({userInputCode: e.target.value.toLowerCase()});
  }

  submit = (e) => {
    const {form, dispatch} = this.props;
    e.preventDefault();
    form.validateFields({force: true},
      (err, values) => {
        if (!err) {
          dispatch({type: 'vadpLogin/login', payload: {...values, reloadPic: this.reloadPic}});
        }
      },
    );
  }

  renderErrorMessage = (message) => {
    return (
      <Alert
        style={{marginBottom: 16}}
        message={message}
        type="error"
        showIcon
      />
    );
  }

  frogetPassword = () => {
    const {dispatch} = this.props;
    dispatch({type: 'resetPassword/getSysPasswordConfig', payload: {}});
  }

  render() {
    const {form, loginStatus, loginImageLight, loading, theme, loginImageDark, errorMessage, showLoginVerify, showLoginDate} = this.props;
    const {showVerify,isPasswordEye} = this.state;
    const lightImages = {
      image: loginImageLight,
    };
    const darkImages = {
      image: loginImageDark,
    };
    const isDark = theme !== 'light';
    const images = !isDark ? lightImages : darkImages;
    const fillFixClass = isDark ? 'autofillLight' : 'autofillLight';
    const {getFieldDecorator, getFieldsValue} = form;
    const {username = '', password = '', code = ''} = getFieldsValue();
    const dateFormat = 'YYYY/MM/DD';
    const submitButtonDisabled = showLoginVerify ? username !== '' && password !== '' && (code.toLowerCase() === this.state.code.toLowerCase()) : true;
    const suffix =
      <div style={{height: 30}}>
        <canvas
          onClick={this.reloadPic}
          ref={this.canvas}
          width='100'
          height='30'>
        </canvas>
      </div>;
    return (
      <div
        style={{
          background: `url(${wrapImage(`/static/images/${images.image}`)}) top no-repeat`,
          backgroundSize: 'cover',
        }}
        className={`${styles.vadpLogin} ${fillFixClass}`}>
        <div className={showLoginVerify ? styles.container : styles.containerNormal}>
          <span className={styles.title}>用户登录</span>
          {!loginStatus && this.renderErrorMessage(errorMessage)}
          <Form onSubmit={this.submit} className={styles.form}>
            <FormItem>
              {getFieldDecorator('username', {
                rules: [{
                  required: true, message: '请输入用户名！',
                }],
              })(
                <Input
                  autocomplete="off"
                  placeholder="用户名"
                  onChange={this.onChange}
                  onPressEnter={() => {
                    document.getElementById('password').focus();
                  }}
                  prefix={<Icon type="-user1" style={{color: '#A7A7A7'}}/>}
                />
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('password', {
                rules: [{
                  required: true, message: '请输入密码！',
                }],
              })(
                <Input
                  type={ isPasswordEye ? 'text' : 'password' }
                  placeholder="密码"
                  autocomplete="off"
                  onChange={this.onChange}
                  prefix={<Icon type="-password1" style={{color: '#A7A7A7'}}/>}
                  suffix={
                      <span onMouseDown={(e)=>this.mousedownEye(e)} className="icon iconfont icon-view" style={{ color: isPasswordEye? '#1890ff' : '#A7A7A7',cursor:'pointer'}}>
                      </span>
                  }
                />
              )}
            </FormItem>

            {showLoginDate && <DatePicker
              locale={locale}
              style={{marginBottom: 16}}
              format={dateFormat}
              defaultValue={moment(Date.now())}
              onChange={this.onDateChange}
              allowClear={false}/>}

            {showVerify && <FormItem>
              {getFieldDecorator('code', {
                rules: [{
                  required: true, message: '请输入校验码！',
                }],
              })(
                <Input
                  maxLength={4}
                  suffix={suffix}
                  onChange={this.changeCode}
                  placeholder="请输入校验码"
                />
              )}
            </FormItem>}
            <FormItem>
              <Button
                disabled={!submitButtonDisabled}
                size="large"
                className="login-submit-btn"
                type="primary"
                htmlType="submit"
                loading={loading}>
                登录
              </Button>
              <div>
                {getFieldDecorator('remember', {
                  valuePropName: 'checked',
                  initialValue: true,
                })(<Checkbox>记住用户名</Checkbox>)}
                <a style={{float:'right'}} onClick={this.frogetPassword}>忘记密码?</a></div>
            </FormItem>
          </Form>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    loginBackgroundImageLight: state.vadpLogin.loginBackgroundImageLight,
    loginLogoLight: state.vadpLogin.loginLogoLight,
    loginImageLight: state.vadpLogin.loginImageLight,
    loginLogo: state.vadpLogin.loginLogo,
    testLight: state.vadpLogin.testLight,
    theme: state.vadpLogin.theme,
    errorMessage: state.vadpLogin.errorMessage,
    loginImageDark: state.vadpLogin.loginImageDark,
    showLoginVerify: state.vadpLogin.showLoginVerify,
    showLoginDate: state.vadpLogin.showLoginDate,
  };
}

export default connect(mapStateToProps)(Form.create()(Login));



// WEBPACK FOOTER //
// ./src/components/Login/index.js